module.exports = __webpack_public_path__ + "public/img/guge.f0ebe659.png";